export default {
  noopen: '职位已停止对外公开',
  preview: {
    dialogTitle: '职位预览',
  },
  form: {
    title: {
      create: '创建职位',
      edit: '编辑职位',
    },
    sections: {
      basicInfo: '招聘细则',
      requirements: '应聘条件',
      workSchedule: '劳动条件',
      salaryBenefits: '薪资与福利',
      otherInfo: '其他',
    },
    buttons: {
      save: '保存',
      publish: '发布',
      saveAndPublish: '保存&发布',
      cancel: '取消',
      goToInterviewProcess: '管理选考流程',
      goToAffiliation: '勤務先管理',
    },
    fieldFilters: {
      all: '全部字段',
      open: '公开字段',
      agent: '仅猎头可见字段',
    },
    jobTitle: '标题',
    positionType: '岗位类型',
    enterprise: '招聘企业',
    jobIndustry: '行业',
    headcount: '招聘人数',
    recruitGraduateType: '招聘对象',
    hasJobTransfer: '转岗',
    isUrgent: '是否急聘',
    employmentForm: '雇佣形式',
    hasEmploymentTerm: '雇佣期限',
    hasProbation: '试用期',
    jobDescription: '工作内容',
    careerPath: '职业路径',
    workplaceAtmosphere: '职场氛围',
    workplaceAtmosphereAgentNote: '补充说明（面向猎头）',
    agentOnly: '仅猎头可见',
    recruitmentProcessId: '选考流程',
    selectionProcessNote: '选考流程说明',
    interviewMethod: '面试方式',
    expectedStartDate: '希望入职时间',
    additionalNoteForAgent: '补充说明',
    japaneseLevelId: '日语水平',
    requirementNote: '必要条件',
    extraPointColumn: '加分项',
    hasCertificationReq: '资格要求',
    requiredExperience: '所需经验 ／人选画像',
    requiredExperienceAgentNote: '所需经验／人选画像（面向猎头）',
    overseasApplication: '海外人才申请',
    ageLimit: '年龄限制',
    ageLimitCondition: '适用年龄限制的条件',
    nationalityLimit: '国籍限制',
    nationalityLimitReason: '适用国籍限制的正当理由',
    otherRequirements: '其他要求',
    otherNote: '备注（面向猎头的信息）',
    affiliationId: '勤務先',
    affiliationNote: '勤務先补充说明',
    affiliationStructure: '勤務先人员构成',
    workAddress: '工作地址',
    nearestStation: '最近车站',
    workingHours: '工作时间',
    workingHoursNote: '工作时间说明',
    stipulatedWorkTime: '规定劳动时间',
    hasShifts: '轮班工作',
    hasFlextime: '弹性工作制',
    overtimeHours: '预计加班时长',
    weeklyOffType: '周休',
    annualHolidays: '年度休息日',
    paidHolidaysRange: '带薪年假',
    otherLeaves: '其他休假',
    monthlyTotal: '月总支付金额',
    payMode: '薪酬模式',
    baseSalary: '基本薪资',
    baseSalaryNote: '月总支付金额说明',
    hasBonus: '奖金',
    hasTransportAllowance: '交通补贴',
    hasOvertimePay: '加班补贴',
    hasNightShiftAllowance: '夜班补贴',
    hasOverseasWorkerTravelExpenseSupport: '海外应聘者的差旅费补贴',
    otherAllowances: '其他补贴',
    probationPay: '试用期/研修期工资',
    probationPayNote: '试用期/研修期工资说明',
    hasSalaryIncrease: '加薪',
    socialInsuranceInfo: '社会保险',
    hasHousingSupport: '住房支持',
    hasVisaSupport: '签证支持',
    otherSupports: '其他支持',
    remarks: '其他说明',
    appDisplayImages: 'APP 端展示图片',
    appImagesSyncButton: '自动同步',
    appImagesUploadButton: '上传',
    appImagesTip: '限 jpg/jpeg/png/webp 格式,单个文件最小于 10 MB,不超过 6 张。可自动同步勤務先已上传的图片,也可以重新上传。',
    appImagesMaxCountWarning: '最多只能上传 6 张图片',
    appImagesFormatError: '格式不正确,仅支持 jpg/jpeg/png/webp 格式',
    appImagesSizeError: '大小超过 10 MB',
    appImagesSyncInfo: '同步功能待实现',
    otherDocumentsTitle: '其他资料',
    otherDocumentsUploadButton: '上传',
    otherDocumentsTip: '限 jpg/jpeg/png/webp/docx/doc/xlsx/xls/pdf 格式,单个文件最小于 10 MB',
    otherDocumentsEmpty: '暂无上传文件',
    otherDocumentsFormatError: '格式不正确,仅支持 jpg/jpeg/png/webp/doc/xlsx/xls/pdf 格式',
    otherDocumentsSizeError: '大小超过 10 MB',
    otherDocumentsMaxError: '最多支持上传 {max} 个文件',
    otherDocumentsExceedLimit: '选择的文件数过多,最多{max}个,还可上传{remaining}个',
    options: {
      yes: '是',
      no: '否',
      has: '有',
      hasNot: '无',
      have: '有',
      noAsk: '无',
      none: '无',
      can: '可以',
      cannot: '不可以',
      online: '线上',
      offline: '线下',
      formalEmployee: '正式员工',
      contractEmployee: '合同员工',
      partTimeEmployee: '兼职员工',
      fullWeekendOff: '完全周休二日制',
      weekendOff: '周休二日制',
      shiftSystem: 'シフト制',
      other: '其他',
      otherOnlineOrOffline: '対面及びWEB',
      hourPerDay: '小时/日',
      hourPerWeek: '小时/周',
      hourPerMonth: '小时/月',
      perHour: '每小时',
      perDay: '每天',
      perMonth: '每月',
      perYear: '每年',
      allowanceHealth: '健康保险',
      allowanceWelfare: '厚生年金保険',
      allowanceCompensation: '劳灾保険',
      allowanceEmployment: '雇用保険',
      publicOpened: '已公开',
      publicUnopened: '未公开',
      noOpenToAgent: '未开放',
      openedToAgent: '已开放',
      stopOpenedToAgent: '停止开放',
    },
    validation: {
      titleRequired: '请输入职位标题',
      positionTypeRequired: '请选择岗位类型',
      positionTypeInputRequired: '请输入岗位类型',
      jobIndustryRequired: '请选择行业',
      headcountRequired: '请输入招聘人数',
      headcountPositiveInteger: '请输入正整数',
      recruitGraduateTypeRequired: '请选择招聘对象',
      hasJobTransferRequired: '请选择转岗',
      hasJobTransferInput: '请输入转岗说明',
      isUrgentRequired: '请选择是否急聘',
      employmentFormRequired: '请选择雇佣形式',
      jobDescriptionRequired: '请输入工作内容',
      careerPathRequired: '请输入职业路径',
      recruitmentProcessIdRequired: '请选择选考流程',
      recruitmentProcessNoteRequired: '请填写选考流程说明',
      japaneseLevelIdRequired: '请选择日语水平',
      requirementNoteRequired: '请输入必要条件',
      hasCertificationReqRequired: '请选择资格要求',
      hasCertificationReqInput: '请输入资格要求',
      requiredExperienceRequired: '请输入所需经验 ／人选画像',
      affiliationIdRequired: '请选择勤務先',
      affiliationStructureRequired: '请输入勤務先人员构成',
      workAddressRequired: '请输入工作地址',
      workingHoursRequired: '请选择工作时间',
      hasShiftsRequired: '请选择轮班工作',
      hasShiftsInput: '请输入轮班工作说明',
      hasFlextimeRequired: '请选择弹性工作制',
      hasFlextimeInput: '请输入弹性工作制说明',
      overtimeHoursRequired: '请选择预计加班时长',
      overtimeHoursInput: '请输入预计加班时长',
      weeklyOffTypeRequired: '请选择周休',
      weeklyOffOtherNoteRequired: '请输入周休其他说明',
      monthlyTotalRequired: '请选择月总支付金额',
      monthlyTotalRangeRequired: '请输入月总支付金额范围',
      monthlyTotalInputRequired: '请输入月总支付金额',
      baseSalaryRequired: '请选择基本薪资',
      baseSalaryRangeRequired: '请输入基本薪资范围',
      baseSalaryInputRequired: '请输入基本薪资',
      hasBonusRequired: '请选择奖金',
      hasBonusInput: '请输入奖金说明',
      hasTransportAllowanceRequired: '请选择交通补贴',
      hasTransportAllowanceInput: '请输入交通补贴说明',
      hasOvertimePayRequired: '请选择加班补贴',
      hasOvertimePayInput: '请输入加班补贴说明',
      hasNightShiftAllowanceRequired: '请选择夜班补贴',
      hasNightShiftAllowanceInput: '请输入夜班补贴说明',
      hasOverseasWorkerTravelExpenseSupportRequired: '请选择海外应聘者的差旅费补贴',
      hasOverseasWorkerTravelExpenseSupportInput: '请输入海外应聘者的差旅费补贴说明',
      hasSalaryIncreaseRequired: '请选择加薪',
      hasSalaryIncreaseInput: '请输入加薪说明',
      socialInsuranceInfoRequired: '请选择社会保险',
      hasHousingSupportRequired: '请选择住房支持',
      hasHousingSupportInput: '请输入住房支持说明',
      hasVisaSupportRequired: '请选择签证支持',
      hasVisaSupportInput: '请输入签证支持说明',
      probationPayRequired: '请选择试用期/研修期工资',
      probationPayRangeRequired: '请输入试用期/研修期工资范围',
      probationPayInputRequired: '请输入试用期/研修期工资',
      endTimeMustBeAfterStartTime: '结束时间不能早于开始时间',
      overseasApplicationInput: '请输入海外人才申请',
      ageLimitInput: '请输入年龄限制',
      ageLimitConditionRequired: '请输入适用年龄限制的条件',
      nationalityLimitInput: '请输入国籍限制',
      nationalityLimitConditionRequired: '请输入适用国籍限制的正当理由',
      otherRequirementsRequired: '请选择其他要求',
      otherRequirementsInput: '请输入其他要求',
      interviewMethodRequired: '请选择面试方式',
      interviewMethodInput: '请输入面试方式',
      hiddenFieldsErrorTitle: '对外公开字段未通过校验',
      hiddenFieldsErrorContent: '恢复展示全部字段后可查看',
      viewNow: '立即查看'
    },
    placeholder: {
      pleaseEnter: '请输入',
      pleaseSelect: '请选择',
      workAddressNote: '选择勤務先后会自动同步勤務先地址',
      nearestStation: '选择勤務先后会自动同步最近车站',
      affiliationStructureNote: '选择勤務先后会自动同步勤務先人员构成',
      selectionProcessNote: '选择选考流程后自动更新',
      monthlyTotal: '例如：月薪 = 基本工资 + 加班费 + 住房补贴',
      payMode: '例如：月薪 = 基本工资 + 加班费 + 住房补贴',
      baseSalaryNote: '例：年収350万～500万＋決算賞与（年1回）',
      hasTransportAllowance: '例如：上限',
      otherAllowances: '例如：餐补',
      hasSalaryIncrease: '例如：每年 1次，5000日元/月',
      workingHoursNote: '在上述时间段内实行轮班制',
      hasHousingSupport: '例如：员工宿舍、公司承租住房、住房补贴',
      hasJobTransfer: '例如：可能在全国店铺之间调岗',
      hasAgeLimit: '18岁-40岁',
      hasNationalityLimit: '因无法为越南籍人士提供注册支援机构相关业务的对接服务，暂难以接纳。',
      hasCertificationReq: '例如：厨师资格，驾照等',
      hasShifts: '例如：在10点到23点之间的8小时（根据店铺的排班）',
      hasFlextime: '例如：以一个月为单位。平均每个月每周40小时以内',
      paidHolidaysRange: '例如：入社6个月之后给10天，之后按法律规定赋予',
      hasBonus: '例如：一年一次（12月）发放，去年实际发放基本工资的2个月份',
      hasOvertimePay: '例如：有固定加班费（30小时6万日元），超过的部分需按照法律规定额外发放',
      hasOverseasWorkerTravelExpenseSupport: '例如：决定录取后，伴随着入社，支付实际发生的飞机票费用（上限10万）',
      hasVisaSupport: '例如：帮助写申请书，支援更新手续等',
      otherRequirements: '可处理猪肉、牛肉类食材。酒精消毒为硬性要求。'
    },
    messages: {
      loadDataFailed: '加载数据失败',
      saving: '保存中...',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      publishing: '发布中...',
      publishSuccess: '发布成功',
      publishFailed: '发布失败',
      saveAndPublishSuccess: '保存并发布成功',
      saveAndPublishFailed: '保存并发布失败'
    }
  },
  breadcrumb: {
    jobManagement: '职位管理',
    jobDetail: '职位详情'
  },
  status: {
    PUBLISHED: '已发布',
    WAIT_PUBLISH: '待发布',
    AUDIT_FAILED: '审核未通过',
    CLOSED: '已关闭'
  },
  detail: {
    positionType: '岗位类型',
    status: '在留资格',
    employmentType: '雇佣形式',
    location: '勤務先',
    recruitCount: '招聘人数',
    isUrgent: '是否紧急',
    updatedAt: '更新时间',
    createdAt: '创建时间',
    creator: '创建人',
    openToAgent: '对猎头开放',
    publicOpen: '对外公开',
    preview: '预览',
    downloadQrCode: '下载二维码',
    copyPublicPageUrl: '复制公开页面地址',
    remarkLabel: '备注',
    onlyPublishedJobCanOpen: '仅已发布职位支持对外公开',
    tabs: {
      jobInfo: '职位信息',
      candidates: '投递候选人',
      changeLog: '变更记录'
    },
    sections: {
      recruitmentDetails: '招聘细则',
      requirements: '应聘条件',
      workingHours: '劳动条件',
      salary: '薪资与福利',
      other: '其他'
    },
  },
  candidateList: {
    totalCount: '共计',
    items: '条',
    allStatus: '全部状态',
    candidateColumn: '候选人',
    candidateStatus: '选考状态',
    progressColumn: '选考进度',
    channelColumn: '应聘渠道',
    applyTimeColumn: '应聘时间',
    actionColumn: '操作',
    viewDetail: '选考详情',
    resumeScreening: '简历筛选',
    interview1: '一面',
    interview1Pending: '一面待约',
    interview1Waiting: '一面待接受',
    interview1Scheduled: '一面待面',
    interview2: '二面',
    interview2Pending: '二面待约',
    interview2Waiting: '二面待接受',
    interview2Scheduled: '二面待面',
    offer: '内定',
    offerMade: '内定',
    onboarding: '入职',
    onboardingConfirmed: '特确定入职',
    onboardingPending: '待入职',
    onboarded: '已入职',
    appChannel: 'APP 投递',
    selfRegister: '自社注册',
    noApplicationData: '暂无投递数据',
    isStop: '已终止',
  },
  changeLog: {
    changeTime: '变更时间',
    changer: '变更人',
    changeType: '变更类型',
    fieldName: '字段名',
    oldValue: '变更前',
    newValue: '变更后',
    edit: '编辑',
    create: '新建',
    publish: '发布'
  },
  createDialog: {
    title: '创建职位',
    residenceTypeLabel: '在留资格',
    specificSkill: '特定技能',
    technicalHumanities: '技人国',
    activitiesOutsideStatus: '资格外活动',
    cancel: '取消',
    create: '创建',
    validation: {
      residenceTypeRequired: '请选择在留资格'
    },
    createSuccess: '创建成功',
    createFailed: '创建失败'
  },
  list: {
    title: '职位管理',
    filters: {
      jobId: '职位 ID',
      jobIdPlaceholder: '请输入',
      positionType: '岗位类型',
      positionTypePlaceholder: '请选择',
      residenceStatus: '在留资格',
      residenceStatusPlaceholder: '请选择',
      employmentForm: '雇佣形式',
      employmentFormPlaceholder: '请选择',
      affiliation: '勤務先',
      affiliationPlaceholder: '请选择',
      affiliationSearchPlaceholder: '输入关键字搜索',
      jobTitle: '职位标题',
      jobTitlePlaceholder: '请输入',
      createDate: '创建日期',
      openDate: '职位开放日期',
      creator: '创建人',
      creatorPlaceholder: '请选择',
      openToAgent: '对猎头开放',
      publicOpen: '对外公开',
      moreFilters: '更多筛选'
    },
    searchButton: '查询',
    resetButton: '重置',
    createButton: '创建职位',
    batchOperations: {
      button: '批量操作',
      close: '批量关闭职位',
      openToAgent: '批量对代理开放',
      publicOpen: '批量对外公开',
      publicClose: '批量对外不公开',
      publicOpenBtn: '对外公开',
      publicCloseBtn: '对外不公开',
      closeConfirmTitle: '批量停止职位',
      closeConfirmContent: '已选择 #count# 个职位。停止职位后将不再接收新的应聘。选考中的候补者不受影响。确认批量停止已选职位吗？',
      viewSelectingJobs: '查看选考中的职位',
      publicOpenTitle: '批量对外公开',
      publicOpenContent: '已选中 {count} 个职位，确认批量对外公开这些职位吗？',
      publicCloseTitle: '批量对外不公开',
      publicCloseContent: '已选中 {count} 个职位，确认批量对外不公开这些职位吗？',
      selectFirst: '请先选择要操作的职位',
      closeSuccess: '批量关闭成功',
      closeFailed: '批量关闭失败',
      openToAgentSuccess: '批量对代理开放成功',
      openToAgentFailed: '批量对代理开放失败',
      publicOpenSuccess: '批量对外公开成功',
      publicOpenFailed: '批量对外公开失败',
      publicCloseSuccess: '批量对外不公开成功',
      publicCloseFailed: '批量对外不公开失败'
    },
    tabs: {
      published: '已发布',
      unpublished: '待发布',
      rejected: '审核未通过',
      closed: '已关闭'
    },
    tableStats: '选中 #selected# 条',
    tableStats2: '共计：#total# 条',
    columns: {
      jobId: '职位 ID',
      positionType: '岗位类型',
      residenceStatus: '在留资格',
      employmentForm: '雇佣形式',
      affiliation: '勤務先',
      jobTitle: '职位标题',
      recruitCount: '招聘人数',
      applicantCount: '投递人数',
      hiredCount: '入职人数',
      openToAgent: '对代理开放',
      notOpen: '未开放',
      opened: '已开放',
      openedAgent: '已开放代理',
      stopped: '停止开放',
      stoppedAgent: '停止开放代理',
      publicStatus: '对外公开',
      publishTime: '发布时间',
      shareTime: '共享时间',
      updateTime: '更新时间',
      auditTime: '审核时间',
      closeTime: '关闭时间',
      createTime: '创建时间',
      creator: '创建人',
      rejectionReason: '未通过原因',
      operations: '操作',
      publicStatusOpen: '已公开',
      publicStatusClose: '未公开'
    },
    operations: {
      detail: '详情',
      edit: '编辑',
      copy: '复制',
      close: '关闭',
      publish: '发布',
      delete: '删除',
      openToAgent: '对代理开放'
    },
    emptyStates: {
      noConditions: {
        title: '暂无数据',
        description: '还没有创建职位'
      },
      noResults: {
        title: '查询无结果',
        description: '可尝试修改查询条件'
      }
    },
    deleteDialog: {
      confirmTitle: '确认删除职位',
      confirmContent: '删除后不可恢复，确认删除职位「{jobId}」吗？',
      notAllowedTitle: '暂不支持删除职位',
      notAllowedContent: '职位「{jobId}」下有选考记录，暂不支持删除。'
    },
    closeDialog: {
      confirmTitle: '确认关闭职位',
      confirmContent: '停止职位后将不再接收新的应聘。选考中的候补者不受影响。确认停止职位「{jobId}」吗？',
      tableHeaders: {
        job: '职位',
        resumeScreening: '书类选考',
        interview: '面试'
      }
    },
    publishDialog: {
      confirmTitle: '发布职位',
      confirmContent: '确认发布职位「{jobId}」吗？',
      incompleteTitle: '发布职位',
      incompleteContent: '有必填字段尚未填写，完善信息后可发布。',
      goComplete: '去完善'
    },
    publicDialog: {
      openTitle: '对外公开',
      openContent: '确认对外公开职位「{jobId}」吗？',
      openButton: '对外公开',
      closeTitle: '对外不公开',
      closeContent: '确认对外不公开职位「{jobId}」吗？',
      closeButton: '对外不公开'
    }
  },
  dialog: {
    openToAgent: {
      title: '对猎头开放',
      description: '将职位「{jobId}」对以下猎头公司开放：',
      label: '猎头公司',
      selectAgentRequired: '请选择猎头公司',
      selectJobRequired: '请选择职位',
      success: '对猎头开放成功',
      failed: '对猎头开放失败',
      bottomTip: '停止共享职位后，该猎头公司将无法接收新的应聘。选考中的候补者不受影响。'
    },
    batchOpenToAgent: {
      title: '批量对猎头开放',
      description: '将已选中的 {count} 个职位对以下猎头公司开放：',
      label: '猎头公司',
      selectAgentRequired: '请选择猎头公司',
      selectJobRequired: '请选择职位',
      success: '批量对猎头开放成功',
      failed: '批量对猎头开放失败'
    }
  },
  agentManage: {
    title: '猎头管理',
    filters: {
      company: '猎头公司',
      companyPlaceholder: '请选择',
      contact: '联系人',
      contactPlaceholder: '请选择',
      email: '联系人邮箱',
      emailPlaceholder: '请选择',
      tag: '标签',
      tagPlaceholder: '请选择'
    },
    searchButton: '查询',
    resetButton: '重置',
    columns: {
      company: '猎头公司',
      address: '公司地址',
      contact: '联系人',
      email: '联系人邮箱',
      remark: '备注',
      tags: '标签',
      updatedBy: '更新人',
      updatedAt: '更新时间',
      operations: '操作'
    },
    operations: {
      edit: '编辑'
    },
    emptyStates: {
      noConditions: {
        title: '暂无数据'
      },
      noResults: {
        title: '未搜索到结果',
        description: '请尝试更改搜索条件'
      }
    },
    editDialog: {
      title: '编辑猎头信息',
      contact: '联系人',
      contactPlaceholder: '请输入',
      email: '联系人邮箱',
      emailPlaceholder: '请输入',
      remark: '备注',
      remarkPlaceholder: '请输入',
      tags: '标签',
      tagsPlaceholder: '添加标签',
      addTag: '添加',
      cancel: '取消',
      save: '保存',
      validation: {
        contactRequired: '请输入联系人',
        emailRequired: '请输入联系人邮箱',
        emailFormat: '邮箱格式不正确'
      }
    },
    tableStats: '共计：#total# 条'
  },
  agentList: {
    title: '职位管理',
    filters: {
      enterprise: '招聘企业',
      enterprisePlaceholder: '请选择'
    },
    tableStats: '合计：#total# 条',
    columns: {
      jobId: '职位 ID',
      enterprise: '招聘企业',
      jobTitle: '职位标题',
      positionType: '岗位类型',
      residenceStatus: '在留资格',
      employmentForm: '雇佣形式',
      affiliation: '勤務先',
      recruitCount: '招聘人数',
      recommendCount: '推荐人数',
      entryCount: '入职人数',
      outOpen: '对外公开',
      openTime: '职位开放时间',
      updateTime: '更新时间',
      createTime: '创建时间',
      creator: '创建人'
    }
  },
  businessManage: {
    title: '招聘企业',
    filters: {
      company: '招聘企业',
      companyPlaceholder: '请选择',
      contact: '联系人',
      contactPlaceholder: '请选择',
      email: '联系人邮箱',
      emailPlaceholder: '请选择',
      tag: '标签',
      tagPlaceholder: '请选择'
    },
    searchButton: '查询',
    resetButton: '重置',
    columns: {
      company: '招聘企业',
      address: '公司地址',
      affiliation: '勤務先数',
      contact: '联系人',
      email: '联系人邮箱',
      remark: '备注',
      tags: '标签',
      updatedBy: '更新人',
      updatedAt: '更新时间',
      operations: '操作'
    },
    operations: {
      detail: '详情',
      addTag: '添加标签'
    },
    remarkDialog: {
      title: '备注',
      remarkLabel: '备注',
      remarkPlaceholder: '请输入',
      cancel: '取消',
      save: '保存'
    },
    tagDialog: {
      title: '添加标签',
      tagLabel: '标签',
      addButton: '添加',
      cancel: '取消',
      save: '保存'
    },
    detailDrawer: {
      title: '企业信息',
      tabs: {
        basicInfo: '基本信息',
        supportOrg: '注册支援机构',
        responsiblePerson: '负责人信息'
      },
      basicInfo: {
        legalPerson: '法人',
        corporateNumber: '法人编号（13位）',
        companyType: '公司类型',
        registrationDate: '注册日期',
        capital: '注册资本（日元）',
        companySize: '公司规模',
        foreignEmployeeScale: '外籍员工规模',
        revenueScale: '营收规模（日元/年）',
        websiteUrl: '公司官网',
        address: '公司地址',
        companyIntroduction: '公司介绍',
      },
      supportOrg: {
        legalPerson: '法人',
        corporateNumber: '法人编号（13位）',
        companyType: '公司类型',
        supportMethod: '支援方式',
        delegationMethod: '委托方式',
        remarks: '备注'
      },
      responsiblePerson: {
        name: '姓名',
        position: '职位',
        phone: '电话/手机号',
        email: '邮箱'
      }
    },
    tableStats: '共计：#total# 条'
  }
};
